var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('h1',[_vm._v("AppSheetContactInformation")]),_c('div',{staticClass:"wrapper"},[_c('AppSheetContactInformation',{attrs:{"contact-data":_vm.contactData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }